import { render, staticRenderFns } from "./NavigationLayout.vue?vue&type=template&id=abe524f4&scoped=true"
import script from "./NavigationLayout.vue?vue&type=script&lang=js"
export * from "./NavigationLayout.vue?vue&type=script&lang=js"
import style0 from "./NavigationLayout.vue?vue&type=style&index=0&id=abe524f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe524f4",
  null
  
)

export default component.exports